/**
 *  Input
 *
 *  Created by Legman on 8/10/2015.
 *
 */

"use strict";

/**
 * @constructor
 */
function Input() {
    /**
     * @type {boolean}
     */
    this.isKeyUp = false;

    /**
     * @type {boolean}
     */
    this.isKeyLeft = false;

    /**
     * @type {boolean}
     */
    this.isKeyRight = false;

    /**
     * @type {boolean}
     */
    this.isKeyDown = false;

    /**
     * @type {boolean}
     */
    this.isKeyFire = false;

    /**
     * @type {boolean}
     */
    this.isKeyAltFire = false;

    /**
     * @type {PIXI.Point}
     */
    this.touch = new PIXI.Point();

    /**
     * @type {boolean}
     */
    this.isTouch = false;

    /**
     * @type {*}
     */
    this.signals                = {};
    this.signals.mouseMove      = new signals.Signal();
    this.signals.mouseDown      = new signals.Signal();
    this.signals.mouseUp        = new signals.Signal();
    this.signals.mouseOut       = new signals.Signal();
    this.signals.mouseClick     = new signals.Signal();

    this.signals.keyDown        = new signals.Signal();
    this.signals.keyUp          = new signals.Signal();

    /**
     * @type {null}
     * @private
     */
    this._stage = null;
}
module.exports = Input;

/**
 * @type {*}
 */
Input.keys = {};

/**
 * @type {number}
 * @static
 * @const
 */
Input.keys.W = 87;

/**
 * @type {number}
 * @static
 * @const
 */
Input.keys.A = 65;

/**
 * @type {number}
 * @static
 * @const
 */
Input.keys.S = 83;

/**
 * @type {number}
 * @static
 * @const
 */
Input.keys.D = 68;

/**
 * @type {number}
 * @static
 * @const
 */
Input.keys.Z = 90;

/**
 * @type {number}
 * @static
 * @const
 */
Input.keys.X = 88;

/**
 * @type {number}
 * @static
 * @const
 */
Input.keys.C = 67;

/**
 * @type {number}
 * @static
 * @const
 */
Input.keys.SPACE = 32;

/**
 * @type {number}
 * @static
 * @const
 */
Input.keys.LEFT = 37;

/**
 * @type {number}
 * @static
 * @const
 */
Input.keys.RIGHT = 39;

/**
 * @type {number}
 * @static
 * @const
 */
Input.keys.UP = 38;

/**
 * @type {number}
 * @static
 * @const
 */
Input.keys.DOWN = 40;

/**
 * @type {number}
 * @static
 * @const
 */
Input.keys.ENTER = 13;

/**
 * @param {!PIXI.DisplayObject} stage
 * @param {!*} keyListener
 */
Input.prototype.init = function(stage, keyListener) {
    this._stage                 = stage;
    this._stage.interactive     = true;
    this._stage.mousemove       = this._stage.touchmove     = this.onMouseMove.bind(this);
    this._stage.mousedown       = this._stage.touchstart    = this.onMouseDown.bind(this);
    this._stage.mouseup         = this._stage.touchend      = this.onMouseUp.bind(this);
    this._stage.mouseout                                    = this.onMouseOut.bind(this);
    this._stage.click           = this._stage.tap           = this.onMouseClick.bind(this);

    keyListener.onkeydown       = this.onKeyDown.bind(this);
    keyListener.onkeyup         = this.onKeyUp.bind(this);
    keyListener.focus();
};

Input.prototype.dispose = function() {
    this._stage.mousemove   = this._stage.touchmove     = null;
    this._stage.mousedown   = this._stage.touchstart    = null;
    this._stage.mouseup     = this._stage.touchend      = null;
    this._stage.mouseout                                = null;
    this._stage.click       = this._stage.tap           = null;

    this.signals.mouseMove.dispose();
    this.signals.mouseDown.dispose();
    this.signals.mouseUp.dispose();
    this.signals.mouseOut.dispose();
    this.signals.mouseClick.dispose();

    this.signals.keyDown.dispose();
    this.signals.keyUp.dispose();
};

/**
 * @param {!Event} event
 */
Input.prototype.onMouseMove = function(event) {
    this.touch = event.data.getLocalPosition(this._stage);
    p3.Timestep.queueCall(function() {
        this.signals.mouseMove.dispatch(event);
    }, [], this);
};

/**
 * @param {!Event} event
 */
Input.prototype.onMouseDown = function(event) {
    this.touch = event.data.getLocalPosition(this._stage);
    this.isTouch = true;

    p3.Timestep.queueCall(function() {
        this.signals.mouseDown.dispatch(event);
    }, [], this);
};

/**
 * @param {!Event} event
 */
Input.prototype.onMouseUp = function(event) {
    this.touch = event.data.getLocalPosition(this._stage);
    this.isTouch = false;

    p3.Timestep.queueCall(function() {
        this.signals.mouseUp.dispatch(event);
    }, [], this);
};

/**
 * @param {!Event} event
 */
Input.prototype.onMouseOut = function(event) {
    this.touch = event.data.getLocalPosition(this._stage);
    this.isTouch = false;

    p3.Timestep.queueCall(function() {
        this.signals.mouseOut.dispatch(event);
    }, [], this);
};

/**
 * @param {!Event} event
 */
Input.prototype.onMouseClick = function(event) {
    p3.Timestep.queueCall(function() {
        this.signals.mouseClick.dispatch(event);
    }, [], this);
};

/**
 * @param {!Event} event
 */
Input.prototype.onKeyDown = function(event) {
    switch (event.keyCode) {
        case Input.keys.UP :
        case Input.keys.W : {
            this.isKeyUp = true;
            break;
        }
        case Input.keys.LEFT :
        case Input.keys.A : {
            this.isKeyLeft = true;
            break;
        }
        case Input.keys.RIGHT :
        case Input.keys.D : {
            this.isKeyRight = true;
            break;
        }
        case Input.keys.DOWN :
        case Input.keys.S : {
            this.isKeyDown = true;
            break;
        }
        case Input.keys.Z :
        case Input.keys.SPACE : {
            this.isKeyFire = true;
            break;
        }
        case Input.keys.X : {
            this.isKeyAltFire = true;
            break;
        }
    }

    p3.Timestep.queueCall(function() {
        this.signals.keyDown.dispatch(event);
    }, [], this);
};

/**
 * @param {!Event} event
 */
Input.prototype.onKeyUp = function(event) {
    switch (event.keyCode) {
        case Input.keys.UP :
        case Input.keys.W : {
            this.isKeyUp = false;
            break;
        }
        case Input.keys.LEFT :
        case Input.keys.A : {
            this.isKeyLeft = false;
            break;
        }
        case Input.keys.RIGHT :
        case Input.keys.D : {
            this.isKeyRight = false;
            break;
        }
        case Input.keys.DOWN :
        case Input.keys.S : {
            this.isKeyDown = false;
            break;
        }
        case Input.keys.Z :
        case Input.keys.SPACE : {
            this.isKeyFire = false;
            break;
        }
        case Input.keys.X : {
            this.isKeyAltFire = false;
            break;
        }
    }

    p3.Timestep.queueCall(function() {
        this.signals.keyUp.dispatch(event);
    }, [], this);
};
